import { request } from './_request';
import moment from 'moment'
import {colorArray} from '../helpers/const'

export const changeMarca= (idMarca,idUnidad,nameMarca,nameUnidad,mes) => {

	return (dispatch) => {
		
		  dispatch({ type: 'CHANGE_MARCA_MAIN_DASHBOARD',payload:{idMarca:idMarca,idUnidad:idUnidad,nameMarca:nameMarca,nameUnidad:nameUnidad,mes:mes}});
	  	
		}
};


export const chartsData = (idMarca,idUnidad) => {
	
	return (dispatch,getState) => {
		
	return new Promise((ready) => {
		
		dispatch({ type: 'LOADING_MAIN_DASHBOARD',payload:true});
	   
	    if (!idMarca && !idUnidad)
	    {
	    	idMarca = getState().mainDashboard.idMarca
	   		idUnidad = getState().mainDashboard.idUnidad
	    }

	    let mes = getState().mainDashboard.mes

	    let registro = moment(moment().format("YYYY")+"-"+mes+"-"+"01","YYYY-M-DD").format("YYYY-MM-DD")
	   
	    const user = JSON.parse(localStorage.getItem('@@auth_user'));
        console.log(user)
		request
			.get('/dashboard/charts',{params:{idMarca:idMarca,idUnidad:idUnidad,registro:registro},headers:{'Authorization':`Bearer ${user.token}`}})
			.then((response) => {
				let data = response.data;

				if (!data.error) {

				   let result = data.result

				   dispatch({ type: 'READY_CHARTS_DATA_MAIN_DASHBOARD',
				   	payload:{dataInventarioNuevos:result.inventarioNuevos,
				   		    dataInventarioSeminuevos:result.inventarioSeminuevos,
				   		    dataVentaNuevos:result.ventaNuevos
				   			,keysVentaNuevos:result.keysVentaNuevos,
				   			dataVentaSeminuevos:result.ventaSeminuevos
				   			,keysVentaSeminuevos:result.keysVentaSeminuevos,
				   			 dataVentaServicio:result.ventaServicio
				   			,keysVentaServicioPublico:result.keysVentaServicioPublico,
				   		     dataVentaServicioPublicoLyP:result.ventaServicioPublicoLyP
				   			,keysVentaServicioPublicoLyP:result.keysVentaServicioPublicoLyP,
				   		     dataOrdenesProcesoPublico:result.ordenesProcesoPublico,
				   		     dataTipoOrdenesProceso:result.tipoOrdenesProceso,
				   		     dataTipoOrdenesProcesoLyP:result.tipoOrdenesProcesoLyP,
				   		     dataOrdenesProcesoPublicoLyP:result.ordenesProcesoPublicoLyP,
				   		     dataClasificacionRefacciones:result.clasificacionRefacciones,
				   		     dataCardClasificacionRefaciones:result.cardClasificacionRefaciones,
				   		     dataTemoc:result.temoc,
				   		     dataTemof:result.temof
				   		     }});
  					
				  
				   ready()
				} else {

					if (data.code==-1)
					{
						localStorage.removeItem('@@auth_user');
						dispatch({ type: 'ERROR_TOKEN_MAIN',
							payload:{message:data.message,code:-1}})
						dispatch({ type: 'ERROR_TOKEN_MAIN_DASHBOARD',
							payload:data.message});
					}else
					{
						dispatch({ type: 'ERROR_MAIN_DASHBOARD',
				   			payload:data.message});
					}

				}
			})
			.catch((e) =>
			{
				dispatch({ type: 'ERROR_MAIN_DASHBOARD',
				   	payload:e.message});
			});

		   });
		}
};

export const globalData = (props) => {
	
	return (dispatch) => {
		
	return new Promise((ready) => {
		dispatch({ type: 'LOADING_MAIN_DASHBOARD',payload:true});
	    let registro = moment().subtract(1, "days").format("YYYY-MM-DD")

	    const user = JSON.parse(localStorage.getItem('@@auth_user'));
        console.log(user)
		request
			.get('/dashboard/marcas',{params:{registro:registro},headers: {'Authorization':`Bearer ${user.token}`}})
			.then((response) => {
				let data = response.data;

				if (!data.error) {

				   let marcas = data.result
               
				   dispatch({ type: 'READY_GLOBAL_DATA_MAIN_DASHBOARD',payload:marcas});

				   if (marcas.length>0)
				   {
				   	let itemMarca = marcas[0]
           	       	let itemUnidad = itemMarca.marcaUnidades.length>0?itemMarca.marcaUnidades[0].unidad:{}

				   	dispatch({ type: 'CHANGE_MARCA_MAIN_DASHBOARD',
				   	payload:{idMarca:itemMarca.id,idUnidad:itemUnidad.id,
				   		nameMarca:itemMarca.nombre,nameUnidad:itemUnidad.nombre,mes:Number(moment().format("M"))}});
				   	 
				   	 ready(true)
				   }else
				   {
				   	 ready(false)
				   }

				   
				} else {

					if (data.code==-1)
					{
						localStorage.removeItem('@@auth_user');
						dispatch({ type: 'ERROR_TOKEN_MAIN',
							payload:{message:data.message,code:-1}})
						dispatch({ type: 'ERROR_TOKEN_MAIN_DASHBOARD',
							payload:data.message});
					}else
					{
						dispatch({ type: 'ERROR_MAIN_DASHBOARD',
				   			payload:data.message});
					}

				}
			})
			.catch((e) =>
			{
				dispatch({ type: 'ERROR_MAIN_DASHBOARD',
				   	payload:e.message});
			});

		   });
		}
};